import {
  LayoutBox,
  LayoutColumn,
  LayoutGrid,
  LayoutRow,
} from "../../styled-component";

export default {
  Box: LayoutBox,
  Column: LayoutColumn,
  Row: LayoutRow,
  Grid: LayoutGrid,
};
